




















































import { Component, Mixins, } from "vue-property-decorator";
import { Department } from "../../../domain/department";
import { IMultiSelectableAsynchronously, IMultiSelectableConditionallyAsynchronously } from "../../system/selectors";
import MultiDepartmentListSelector from "../selectors/MultiDepartmentListSelector.vue";
import { IDepartmentListSelectorDialogCondition, instanceOfIDepartmentListSelectorDialogCondition } from "./IDepartmentListSelectorDialogCondition";
import { DepartmentSelectableDialogMixin } from "./mixins";

@Component({
  components: {
    MultiDepartmentListSelector,
  },
})
export default class MultiDepartmentListSelectorDialog extends Mixins(DepartmentSelectableDialogMixin) implements IMultiSelectableAsynchronously<Department>, IMultiSelectableConditionallyAsynchronously<Department, IDepartmentListSelectorDialogCondition> {
  async selectOptions(defaultOptions?: Department[]): Promise<Department[]> {
    return this.show<Department[]>(defaultOptions);
  }

  async selectOptionsConditionally(condition?: IDepartmentListSelectorDialogCondition, defaultOptions?: Department[]): Promise<Department[]> {
    if (instanceOfIDepartmentListSelectorDialogCondition(condition)) {
      this.name = condition.name ? condition.name : "";
      this.nonDisplayDepartmentCodes = condition.nonDisplayDepartmentCodes ? condition.nonDisplayDepartmentCodes : null;
      this.departmentGroup = condition.departmentGroup;
    }
    return this.show<Department[]>(defaultOptions);
  }
}
